'use client';

import { createContext, useContext, type ReactNode } from 'react';
import { useApplicationDiscoveryStatus } from '../../hooks/useApplicationDiscoveryStatus';

type DiscoveryStatusProviderProps = {
  applicationId: string | undefined;
  children: ReactNode;
};

type DiscoveryStatusContextType = {
  isDiscoveryActive: boolean;
  isParametrizationActive: boolean;
  isDeduplicationActive: boolean;
};

const DiscoveryStatusContext = createContext<DiscoveryStatusContextType | null>(
  null,
);

export function DiscoveryStatusProvider({
  applicationId,
  children,
}: DiscoveryStatusProviderProps) {
  const { isDiscoveryActive, isParametrizationActive, isDeduplicationActive } =
    useApplicationDiscoveryStatus({
      applicationId,
      enabled: !!applicationId,
    });

  return (
    <DiscoveryStatusContext.Provider
      value={{
        isDiscoveryActive,
        isParametrizationActive,
        isDeduplicationActive,
      }}
    >
      {children}
    </DiscoveryStatusContext.Provider>
  );
}

export const useDiscoveryStatus = () => {
  const context = useContext(DiscoveryStatusContext);

  if (!context) {
    throw new Error(
      'useDiscoveryStatus must be used within a DiscoveryStatusProvider',
    );
  }

  return context;
};
